// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.app-header {
  background: rgba(0, 0, 0, 0.1);
  color: white;
  padding: 40px 20px;
  text-align: center;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.header-content {
  max-width: 900px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 20px;
}

.header-title {
  flex: 1 1;
}

.header-links {
  display: flex;
  gap: 14px;
  margin-top: 18px;
  flex-wrap: wrap;
}

.header-links a {
  color: rgba(255, 255, 255, 0.92);
  text-decoration: none;
  font-weight: 600;
  font-size: 0.95rem;
}

.header-links a:hover {
  text-decoration: underline;
}

.app-header h1 {
  font-size: 2.5rem;
  margin-bottom: 10px;
}

.app-header p {
  font-size: 1.1rem;
  opacity: 0.9;
}

.home-button {
  background: rgba(255, 255, 255, 0.2);
  color: white;
  border: 1px solid rgba(255, 255, 255, 0.4);
  padding: 10px 20px;
  border-radius: 4px;
  font-size: 1rem;
  cursor: pointer;
  transition: all 0.3s ease;
  font-weight: 500;
  white-space: nowrap;
  margin-top: 5px;
}

.home-button:hover {
  background: rgba(255, 255, 255, 0.3);
  border-color: rgba(255, 255, 255, 0.6);
  transform: translateX(-2px);
}

.home-button:active {
  transform: translateX(-1px);
}

main {
  flex: 1 1;
  padding: 40px 20px;
}

.container {
  max-width: 900px;
  margin: 0 auto;
}

.content-card {
  margin-bottom: 24px;
}

.intro-card h2,
.content-card h2 {
  color: #183153;
  margin-bottom: 14px;
}

.intro-card p,
.content-card p,
.content-card li {
  line-height: 1.7;
}

.eyebrow {
  display: inline-block;
  margin-bottom: 10px;
  font-size: 0.8rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #5f6fd6;
}

.highlight-grid,
.faq-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 16px;
  margin-top: 20px;
}

.highlight-item,
.faq-item {
  border: 1px solid #e7ebff;
  border-radius: 10px;
  padding: 18px;
  background: linear-gradient(180deg, #f9faff 0%, #ffffff 100%);
}

.highlight-item h3,
.faq-item h3 {
  margin-bottom: 10px;
  color: #21345c;
}

.content-list {
  padding-left: 20px;
}

.content-list li + li {
  margin-top: 10px;
}

.ordered-list {
  margin-top: 16px;
}

.content-note {
  margin-top: 16px;
  color: #4c5970;
}

.app-footer {
  background: rgba(0, 0, 0, 0.1);
  color: white;
  padding: 20px;
  text-align: center;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  font-size: 0.9rem;
}

.alert {
  padding: 15px;
  border-radius: 4px;
  margin-bottom: 20px;
  font-weight: 500;
}

.alert-error {
  background-color: #ffebee;
  color: #c62828;
  border-left: 4px solid #c62828;
}

.alert-success {
  background-color: #e8f5e9;
  color: #2e7d32;
  border-left: 4px solid #2e7d32;
}

.alert-warning {
  background-color: #fff3e0;
  color: #e65100;
  border-left: 4px solid #e65100;
}

.alert-info {
  background-color: #e3f2fd;
  color: #1565c0;
  border-left: 4px solid #1565c0;
}
.footer-links {
  margin-top: 15px;
  font-size: 0.875rem;
}

.footer-links a {
  color: rgba(255, 255, 255, 0.9);
  text-decoration: none;
  transition: opacity 0.3s ease;
}

.footer-link-button {
  appearance: none;
  background: none;
  border: 0;
  color: rgba(255, 255, 255, 0.9);
  cursor: pointer;
  font: inherit;
  margin: 0;
  padding: 0;
  text-decoration: none;
}

.footer-links a:hover {
  opacity: 0.7;
  text-decoration: underline;
}

.footer-link-button:hover {
  opacity: 0.7;
  text-decoration: underline;
}

.footer-links .separator {
  margin: 0 10px;
  opacity: 0.6;
}

.cookie-banner {
  position: fixed;
  right: 20px;
  bottom: 20px;
  z-index: 1000;
  width: min(420px, calc(100vw - 40px));
  background: rgba(14, 26, 48, 0.95);
  color: #f3f7ff;
  border: 1px solid rgba(255, 255, 255, 0.14);
  border-radius: 14px;
  box-shadow: 0 18px 44px rgba(0, 0, 0, 0.28);
  padding: 18px;
}

.cookie-banner h3 {
  margin-bottom: 10px;
}

.cookie-banner p {
  font-size: 0.95rem;
  line-height: 1.6;
}

.cookie-banner-links {
  margin-top: 10px;
}

.cookie-banner-links a {
  color: #d5e3ff;
}

.cookie-banner-actions {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  margin-top: 16px;
}

.cookie-banner-accept,
.cookie-banner-essential {
  padding: 10px 14px;
  border-radius: 8px;
  font-weight: 700;
}

.cookie-banner-accept {
  background: #8ad0ff;
  color: #0b213d;
}

.cookie-banner-essential {
  background: transparent;
  border: 1px solid rgba(255, 255, 255, 0.35);
  color: #f3f7ff;
}

.cookie-banner-note {
  margin-top: 12px;
  font-size: 0.82rem;
  color: rgba(243, 247, 255, 0.8);
}

@media (max-width: 768px) {
  .header-content {
    flex-direction: column;
    align-items: stretch;
  }

  .header-links {
    gap: 10px;
  }

  .cookie-banner {
    right: 12px;
    bottom: 12px;
    width: calc(100vw - 24px);
  }
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,6DAA6D;AAC/D;;AAEA;EACE,8BAA8B;EAC9B,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,iDAAiD;AACnD;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gCAAgC;EAChC,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,0CAA0C;EAC1C,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;EACtC,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,SAAO;EACP,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,cAAc;EACd,mBAAmB;AACrB;;AAEA;;;EAGE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;;EAEE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,gBAAgB;AAClB;;AAEA;;EAEE,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,6DAA6D;AAC/D;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,8CAA8C;EAC9C,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,8BAA8B;AAChC;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,SAAS;EACT,+BAA+B;EAC/B,eAAe;EACf,aAAa;EACb,SAAS;EACT,UAAU;EACV,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,aAAa;EACb,qCAAqC;EACrC,kCAAkC;EAClC,cAAc;EACd,2CAA2C;EAC3C,mBAAmB;EACnB,2CAA2C;EAC3C,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,2CAA2C;EAC3C,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,yBAAyB;EAC3B;AACF","sourcesContent":[".App {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n}\n\n.app-header {\n  background: rgba(0, 0, 0, 0.1);\n  color: white;\n  padding: 40px 20px;\n  text-align: center;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.header-content {\n  max-width: 900px;\n  margin: 0 auto;\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 20px;\n}\n\n.header-title {\n  flex: 1;\n}\n\n.header-links {\n  display: flex;\n  gap: 14px;\n  margin-top: 18px;\n  flex-wrap: wrap;\n}\n\n.header-links a {\n  color: rgba(255, 255, 255, 0.92);\n  text-decoration: none;\n  font-weight: 600;\n  font-size: 0.95rem;\n}\n\n.header-links a:hover {\n  text-decoration: underline;\n}\n\n.app-header h1 {\n  font-size: 2.5rem;\n  margin-bottom: 10px;\n}\n\n.app-header p {\n  font-size: 1.1rem;\n  opacity: 0.9;\n}\n\n.home-button {\n  background: rgba(255, 255, 255, 0.2);\n  color: white;\n  border: 1px solid rgba(255, 255, 255, 0.4);\n  padding: 10px 20px;\n  border-radius: 4px;\n  font-size: 1rem;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  font-weight: 500;\n  white-space: nowrap;\n  margin-top: 5px;\n}\n\n.home-button:hover {\n  background: rgba(255, 255, 255, 0.3);\n  border-color: rgba(255, 255, 255, 0.6);\n  transform: translateX(-2px);\n}\n\n.home-button:active {\n  transform: translateX(-1px);\n}\n\nmain {\n  flex: 1;\n  padding: 40px 20px;\n}\n\n.container {\n  max-width: 900px;\n  margin: 0 auto;\n}\n\n.content-card {\n  margin-bottom: 24px;\n}\n\n.intro-card h2,\n.content-card h2 {\n  color: #183153;\n  margin-bottom: 14px;\n}\n\n.intro-card p,\n.content-card p,\n.content-card li {\n  line-height: 1.7;\n}\n\n.eyebrow {\n  display: inline-block;\n  margin-bottom: 10px;\n  font-size: 0.8rem;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: #5f6fd6;\n}\n\n.highlight-grid,\n.faq-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\n  gap: 16px;\n  margin-top: 20px;\n}\n\n.highlight-item,\n.faq-item {\n  border: 1px solid #e7ebff;\n  border-radius: 10px;\n  padding: 18px;\n  background: linear-gradient(180deg, #f9faff 0%, #ffffff 100%);\n}\n\n.highlight-item h3,\n.faq-item h3 {\n  margin-bottom: 10px;\n  color: #21345c;\n}\n\n.content-list {\n  padding-left: 20px;\n}\n\n.content-list li + li {\n  margin-top: 10px;\n}\n\n.ordered-list {\n  margin-top: 16px;\n}\n\n.content-note {\n  margin-top: 16px;\n  color: #4c5970;\n}\n\n.app-footer {\n  background: rgba(0, 0, 0, 0.1);\n  color: white;\n  padding: 20px;\n  text-align: center;\n  border-top: 1px solid rgba(255, 255, 255, 0.1);\n  font-size: 0.9rem;\n}\n\n.alert {\n  padding: 15px;\n  border-radius: 4px;\n  margin-bottom: 20px;\n  font-weight: 500;\n}\n\n.alert-error {\n  background-color: #ffebee;\n  color: #c62828;\n  border-left: 4px solid #c62828;\n}\n\n.alert-success {\n  background-color: #e8f5e9;\n  color: #2e7d32;\n  border-left: 4px solid #2e7d32;\n}\n\n.alert-warning {\n  background-color: #fff3e0;\n  color: #e65100;\n  border-left: 4px solid #e65100;\n}\n\n.alert-info {\n  background-color: #e3f2fd;\n  color: #1565c0;\n  border-left: 4px solid #1565c0;\n}\n.footer-links {\n  margin-top: 15px;\n  font-size: 0.875rem;\n}\n\n.footer-links a {\n  color: rgba(255, 255, 255, 0.9);\n  text-decoration: none;\n  transition: opacity 0.3s ease;\n}\n\n.footer-link-button {\n  appearance: none;\n  background: none;\n  border: 0;\n  color: rgba(255, 255, 255, 0.9);\n  cursor: pointer;\n  font: inherit;\n  margin: 0;\n  padding: 0;\n  text-decoration: none;\n}\n\n.footer-links a:hover {\n  opacity: 0.7;\n  text-decoration: underline;\n}\n\n.footer-link-button:hover {\n  opacity: 0.7;\n  text-decoration: underline;\n}\n\n.footer-links .separator {\n  margin: 0 10px;\n  opacity: 0.6;\n}\n\n.cookie-banner {\n  position: fixed;\n  right: 20px;\n  bottom: 20px;\n  z-index: 1000;\n  width: min(420px, calc(100vw - 40px));\n  background: rgba(14, 26, 48, 0.95);\n  color: #f3f7ff;\n  border: 1px solid rgba(255, 255, 255, 0.14);\n  border-radius: 14px;\n  box-shadow: 0 18px 44px rgba(0, 0, 0, 0.28);\n  padding: 18px;\n}\n\n.cookie-banner h3 {\n  margin-bottom: 10px;\n}\n\n.cookie-banner p {\n  font-size: 0.95rem;\n  line-height: 1.6;\n}\n\n.cookie-banner-links {\n  margin-top: 10px;\n}\n\n.cookie-banner-links a {\n  color: #d5e3ff;\n}\n\n.cookie-banner-actions {\n  display: flex;\n  gap: 10px;\n  flex-wrap: wrap;\n  margin-top: 16px;\n}\n\n.cookie-banner-accept,\n.cookie-banner-essential {\n  padding: 10px 14px;\n  border-radius: 8px;\n  font-weight: 700;\n}\n\n.cookie-banner-accept {\n  background: #8ad0ff;\n  color: #0b213d;\n}\n\n.cookie-banner-essential {\n  background: transparent;\n  border: 1px solid rgba(255, 255, 255, 0.35);\n  color: #f3f7ff;\n}\n\n.cookie-banner-note {\n  margin-top: 12px;\n  font-size: 0.82rem;\n  color: rgba(243, 247, 255, 0.8);\n}\n\n@media (max-width: 768px) {\n  .header-content {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .header-links {\n    gap: 10px;\n  }\n\n  .cookie-banner {\n    right: 12px;\n    bottom: 12px;\n    width: calc(100vw - 24px);\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
